// Components
import { Loading } from "components/feedbacks"
import { Button } from "./Button"

// Icons
import { IconType } from "react-icons"
import { BsFillJournalBookmarkFill } from "react-icons/bs"
import { TbPrinter, TbMail, TbHelp, TbFileTypeXls,TbFileTypePdf, TbDownload, TbTrash, TbPaperclip, TbXboxX } from "react-icons/tb"
import { IoSearch } from "react-icons/io5";

// Types
import { CommandType } from "types"

// Vars
const type: {
  [key: string] : {
    icon: IconType
    text: string
    textClass?: string
  }
} = {
  attachment: {
    icon: TbPaperclip,
    text: "ATTACHMENT"
  },
  cancel: {
    icon: TbXboxX,
    text: "CANCEL",
    textClass: "text-error hover:!text-black"
  },
  delete: {
    icon: TbTrash,
    text: "DELETE RECORD",
    textClass: "text-error hover:!text-black"
  },
  email: {
    icon: TbMail,
    text: "E-MAIL"
  },
  export: {
    icon: TbFileTypeXls,
    text: "EXPORT TO"
  },
  help: {
    icon: TbHelp,
    text: "HELP TIP"
  },
  journal: {
    icon: BsFillJournalBookmarkFill,
    text: "JOURNAL"
  },
  print: {
    icon: TbPrinter,
    text: "PRINT"
  },
  save: {
    icon: TbDownload,
    text: "SAVE RECORD"
  },
  advanced: {
    icon: IoSearch,
    text: "ADVANCED"
  },
  pdf: {
    icon: TbFileTypePdf,
    text: "EXPORT TO"
  },
}

export function CommandButton(params: CommandType) {
  const {
    actiontype,
    label,
    buttonColor,
    className,
    permission,
    loading,
    disabled,
    ...rest
  } = params

  const Icon = type[actiontype].icon
  const isError = buttonColor === "error"

  const layoutClass = isError
    ? "flex flex-col h-16 px-0 w-24 justify-center items-center gap-0.5"
    : "flex flex-col h-16 bg-base-200 border-[1px] border-base-300 px-0 w-24 hover:bg-primary hover:text-black border-white"

  return (
    <Button
      {...rest}
      className={`${layoutClass} ${className ?? ""}`}
      color={isError ? "error" : "ghost"}
      permission={permission}
      disabled={loading === "true" || disabled}
      loading={undefined}
    >
      {loading === "true" ? <Loading loading /> : <Icon size={24} />}
      <div className={isError ? "text-white text-xs font-semibold" : type[actiontype].textClass}>
        {label ?? type[actiontype].text}
      </div>
    </Button>
  )
}